import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Can } from "../Can";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Menu, CircularProgress } from "@material-ui/core";
import {
  DeviceHubOutlined,
  History,
  MoreVert,
  PictureAsPdf,
  SwapHorizOutlined,
  AccountBalanceWallet,
  AccountBalance,
  FileCopy as FileCopyIcon,
  FlashOn,
  Add,
  Tune,
} from "@material-ui/icons";
import { v4 as uuidv4 } from "uuid";
import PixIcon from "@mui/icons-material/Pix";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from "@material-ui/core/Tooltip";
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";

import Button from "@material-ui/core/Button";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
import NewTicketModal from "../NewTicketModal";

//icones
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import UndoIcon from "@material-ui/icons/Undo";

import ScheduleModal from "../ScheduleModal";
import MenuItem from "@material-ui/core/MenuItem";
import { Switch } from "@material-ui/core";
import ShowTicketOpen from "../ShowTicketOpenModal";
import { toast } from "react-toastify";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../../components/ShowTicketLogModal";
import TicketMessagesDialog from "../TicketMessagesDialog";
import { useTheme } from "@material-ui/styles";
import html2pdf from "html2pdf.js";
import FinalizacaoVendaModal from "../FinalizacaoVendaModal";
import QuickMessageModal from "../QuickMessageModal";
import { Phone } from "@material-ui/icons";
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import FloupSelector from "../FloupSelector";
import PauseTicketModal from "../PauseTicketModal";
import { resumeTicket } from "../../services/ticketPauseService";
import confirmDialog from "../../utils/confirmDialog";
import ContactCustomFieldsDrawer from "../ContactCustomFieldsDrawer";

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    marginRight: 6,
    maxWidth: "100%",
    flex: "none",
    alignSelf: "center",
    marginLeft: "auto",
    minWidth: 0,
    // flexBasis: "50%",
    display: "flex",
    gap: 4,
    flexWrap: "nowrap",
    justifyContent: "flex-end",
    "& > *": {
      margin: 0,
    },
  },
  bottomButtonVisibilityIcon: {
    padding: 1,
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  botoes: {
    display: "flex",
    padding: "15px",
    justifyContent: "flex-end",
    maxWidth: "100%",
    // alignItems: "center"
  },
}));

const SessionSchema = Yup.object().shape({
  ratingId: Yup.string().required("Avaliação obrigatória"),
});

const TicketActionButtonsCustom = ({
  ticket,
  contact,
  onQuickMessageSelect,
  onContactUpdated,
  // , showSelectMessageCheckbox,
  // selectedMessages,
  // forwardMessageModalOpen,
  // setForwardMessageModalOpen
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isMounted = useRef(true);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
  const [open, setOpen] = React.useState(false);
  const formRef = React.useRef(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [contactCustomFieldsOpen, setContactCustomFieldsOpen] = useState(false);
  const [contactId, setContactId] = useState(null);
  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);
  const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const [exportPdfChoiceModalOpen, setExportPdfChoiceModalOpen] = useState(false);
  const [pdfExportMode, setPdfExportMode] = useState(null); // 'screen' | 'fullHistory'
  const [disableBot, setDisableBot] = useState(ticket?.contact?.disableBot || false);

  const [showSchedules, setShowSchedules] = useState(false);
  const [enableIntegration, setEnableIntegration] = useState(
    ticket.useIntegration
  );

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [logTicket, setLogTicket] = useState([]);

  const [showWavoipCall, setShowWavoipCall] = useState(false);

  const { get: getSetting } = useCompanySettings();
  const { getPlanCompany } = usePlans();

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const [showTestButton, setShowTestButton] = useState(false);
  const [triggerIntegrationOnCloseMode, setTriggerIntegrationOnCloseMode] =
    useState("ask");
  const [exportedToPDF, setExportedToPDF] = useState(false);
  const [linkingWallet, setLinkingWallet] = useState(false);

  const [openFinalizacaoVenda, setOpenFinalizacaoVenda] = useState(false);
  const [ticketDataToFinalize, setTicketDataToFinalize] = useState(null);
  const [showFinalizacaoOptions, setShowFinalizacaoOptions] = useState(false);
  const [finalizacaoTipo, setFinalizacaoTipo] = useState(null); // 'semDespedida' ou 'comDespedida'
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false);
  const [pauseModalOpen, setPauseModalOpen] = useState(false);
  const [exigirMotivoFinalizacao, setExigirMotivoFinalizacao] = useState(false);

  // Estados para copiar telefone e respostas rápidas
  const [quickMessageModalOpen, setQuickMessageModalOpen] = useState(false);
  const [sendingPixKey, setSendingPixKey] = useState(false);

  useEffect(() => {
    fetchData();
    checkWhatsAppTriggerIntegration();
    fetchDirectTicketsToWalletsSetting();
    fetchExigirMotivoFinalizacao();

    // Cleanup function to set isMounted to false when the component unmounts
    return () => {
      isMounted.current = false;
    };
  }, []);


  const fetchData = async () => {
    const companyId = user.companyId;
    const planConfigs = await getPlanCompany(undefined, companyId);
    
    if (isMounted.current) {
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowWavoipCall(planConfigs.plan.wavoip);
      setOpenTicketMessageDialog(false);
      setDisableBot(ticket?.contact?.disableBot || false);
      setShowTicketLogOpen(false);
    }
  };

  const checkWhatsAppTriggerIntegration = async () => {
    try {
      const { data } = await api.get(`/whatsapp/${ticket.whatsappId}`);
      if (isMounted.current) {
        setShowTestButton(data.triggerIntegrationOnClose === true);
        setTriggerIntegrationOnCloseMode(
          data.triggerIntegrationOnCloseMode || "ask"
        );
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        setShowTestButton(false);
        setTriggerIntegrationOnCloseMode("ask");
      }
    }
  };

  const fetchExigirMotivoFinalizacao = async () => {
    try {
      const setting = await getSetting({ column: "exigirMotivoFinalizacao" });
      if (isMounted.current) {
        const val = setting?.exigirMotivoFinalizacao;
        setExigirMotivoFinalizacao(val === true || val === "true");
      }
    } catch (err) {
      if (isMounted.current) setExigirMotivoFinalizacao(false);
    }
  };

  const fetchDirectTicketsToWalletsSetting = async () => {
    try {
      const setting = await getSetting({
        column: "DirectTicketsToWallets"
      });
      if (isMounted.current) {
        setDirectTicketsToWallets(setting.DirectTicketsToWallets);
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        setDirectTicketsToWallets(false);
      }
    }
  };

  // Função para copiar telefone
  const handleCopyPhone = async () => {
    try {
      if (!contact?.number) {
        toast.error(i18n.t("ticketInfo.noPhone"));
        return;
      }

      // Buscar todas as configurações relacionadas
      let prefix = "";
      let removeCountryCode = false;
      let removeAreaCode = false;
      let remove9thDigit = false;

      try {
        const settings = await Promise.all([
          getSetting({ column: "copyContactPrefix" }),
          getSetting({ column: "removeCountryCodeOnCopy" }),
          getSetting({ column: "removeAreaCodeOnCopy" }),
          getSetting({ column: "remove9thDigitOnCopy" })
        ]);

        prefix = settings[0]?.copyContactPrefix || "";
        removeCountryCode = settings[1]?.removeCountryCodeOnCopy || false;
        removeAreaCode = settings[2]?.removeAreaCodeOnCopy || false;
        remove9thDigit = settings[3]?.remove9thDigitOnCopy || false;
      } catch (err) {
        console.error('Erro ao buscar configurações:', err);
        // Continua com valores padrão se houver erro
      }

      // Remove todos os caracteres não numéricos
      let phoneNumber = contact.number.replace(/\D/g, '');

      // Aplicar transformações conforme checkboxes marcados
      // Ordem de processamento: 1) Código do país, 2) DDD, 3) 9º dígito
      
      // 1. Remover código do país (55) se marcado
      if (removeCountryCode && phoneNumber.startsWith('55') && phoneNumber.length > 10) {
        phoneNumber = phoneNumber.substring(2);
      }

      // 2. Remover código de área (DDD - 2 primeiros dígitos) se marcado
      // O DDD são os 2 primeiros dígitos após o código do país (ou do início se código foi removido)
      if (removeAreaCode) {
        // Número brasileiro completo tem 13 dígitos (55 + DDD + 9 + número)
        // Após remover código do país: 11 dígitos (DDD + 9 + número)
        // Após remover DDD: 9 dígitos (9 + número)
        if (phoneNumber.length >= 10) {
          phoneNumber = phoneNumber.substring(2);
        }
      }

      // 3. Remover 9º dígito (primeiro dígito do número do celular) se marcado
      // O 9º dígito é o primeiro dígito após o DDD
      if (remove9thDigit) {
        // Se o DDD foi removido, o 9º dígito é o primeiro dígito
        // Se o DDD ainda está presente, o 9º dígito é o terceiro dígito (índice 2)
        if (removeAreaCode) {
          // DDD já foi removido, o 9º dígito é o primeiro
          if (phoneNumber.length >= 9) {
            phoneNumber = phoneNumber.substring(1);
          }
        } else {
          // DDD ainda está presente, o 9º dígito é o terceiro (após os 2 do DDD)
          if (phoneNumber.length >= 11) {
            phoneNumber = phoneNumber.substring(0, 2) + phoneNumber.substring(3);
          } else if (phoneNumber.length === 10) {
            // Caso especial: número sem código do país mas com DDD
            phoneNumber = phoneNumber.substring(0, 2) + phoneNumber.substring(3);
          }
        }
      }

      // Se a sigla estiver configurada, adiciona antes do número
      if (prefix && prefix.trim() !== "") {
        phoneNumber = `${prefix}${phoneNumber}`;
      }

      // Verifica se tem pelo menos 8 dígitos (número mínimo válido)
      const digitsOnly = phoneNumber.replace(/\D/g, '');
      if (digitsOnly.length >= 8) {
        await navigator.clipboard.writeText(phoneNumber);
        toast.success(i18n.t("ticketInfo.phonecopied"));
      } else {
        toast.error(i18n.t("ticketInfo.invalidPhoneFormat"));
      }
    } catch (err) {
      console.error('Erro ao copiar telefone:', err);
      toast.error(i18n.t("ticketInfo.copyError"));
    }
  };

  // Funções para respostas rápidas
  const handleOpenQuickMessageModal = () => {
    setQuickMessageModalOpen(true);
  };

  const handleCloseQuickMessageModal = () => {
    setQuickMessageModalOpen(false);
  };

  const handleSendPixKey = async () => {
    if (!ticket?.id) return;
    setSendingPixKey(true);
    try {
      // Buscar chave favorita do multi-key ou fallback para legado
      const { data: settings } = await api.get("/settings");
      const pixKeysConfig = settings.find(s => s.key === "pixKeys");
      let favoriteKey = null;

      if (pixKeysConfig?.value) {
        try {
          const parsed = JSON.parse(pixKeysConfig.value);
          if (Array.isArray(parsed) && parsed.length > 0) {
            favoriteKey = parsed.find(k => k.favorite) || parsed[0];
          }
        } catch (_) {}
      }

      if (favoriteKey) {
        // Enviar chave favorita diretamente via pix_copy
        const PIX_LABELS = { cpf: "CPF", cnpj: "CNPJ", email: "E-mail", celular: "Celular", aleatoria: "Chave Aleatoria" };
        const typeLabel = PIX_LABELS[favoriteKey.type] || "PIX";
        let bodyText = `💠 *PIX*\n`;
        if (favoriteKey.label) bodyText += `🏢 *${favoriteKey.label}*\n`;
        if (favoriteKey.name) bodyText += `👤 *${favoriteKey.name}*\n`;
        bodyText += `📋 *Chave ${typeLabel}:*\n`;
        bodyText += `\`\`\`${favoriteKey.key}\`\`\``;

        await api.post(`/tickets/${ticket.id}/interactive`, {
          type: "pix_copy",
          bodyText,
          copyCode: favoriteKey.key,
        });
      } else {
        // Fallback legado: usa efichavepix via backend
        await api.post(`/messages/${ticket.id}/send-interactive`, {
          type: "pix",
          bodyText: "",
        });
      }
      toast.success(i18n.t("ticketInfo.sendPixKeySuccess") || "Chave PIX enviada no ticket.");
    } catch (err) {
      toastError(err);
    } finally {
      setSendingPixKey(false);
    }
  };

  const handleQuickMessageSelect = useCallback((selectedMessage) => {
    handleCloseQuickMessageModal();

    if (selectedMessage.mediaPath) {
      const event = new CustomEvent('insertQuickMessage', {
        detail: {
          quickMessage: {
            id: selectedMessage.id,
            message: selectedMessage.message || "",
            shortcode: selectedMessage.shortcode || "",
            mediaPath: selectedMessage.mediaPath,
            mediaName: selectedMessage.mediaName || null, // ✅ CORREÇÃO: Incluir mediaName
            mediaType: selectedMessage.mediaType,
            value: selectedMessage.message || ""
          }
        },
        bubbles: false
      });

      window.dispatchEvent(event);
    } else {
      // Para texto, também usar evento
      const event = new CustomEvent('insertQuickMessage', {
        detail: {
          quickMessage: {
            id: selectedMessage.id,
            message: selectedMessage.message || "",
            shortcode: selectedMessage.shortcode || "",
            mediaPath: null,
            mediaName: null,
            mediaType: null,
            value: selectedMessage.message || ""
          }
        },
        bubbles: false
      });

      window.dispatchEvent(event);
    }
  }, []);

  const handleClickOpen = async (e) => {
    const setting = await getSetting({
      column: "requiredTag",
    });

    if (setting?.requiredTag === "enabled") {
      //verificar se tem uma tag
      if (!ticket?.contact?.id) {
        toast.warning("Contato não encontrado");
        return;
      }
      try {
        const contactTags = await api.get(`/contactTags/${ticket.contact.id}`);
        if (!contactTags.data.tags) {
          toast.warning(i18n.t("messagesList.header.buttons.requiredTag"));
        } else {
          setOpen(true);
          // handleUpdateTicketStatus(e, "closed", user?.id);
        }
      } catch (err) {
        toastError(err);
      }
    } else {
      setOpen(true);
      // handleUpdateTicketStatus(e, "closed", user?.id);
    }
  };

  const handleClose = () => {
    formRef.current.resetForm();
    setOpen(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setLoading(false);
  };
  const handleOpenAcceptTicketWithouSelectQueue = async () => {
    setAcceptTicketWithouSelectQueueOpen(true);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenTransferModal = (e) => {
    setTransferTicketModalOpen(true);
    if (typeof handleClose == "function") handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    if (typeof handleClose == "function") handleClose();
  };

  const handleCloseTicketWithoutFarewellMsg = async () => {
    const canClose = await checkCanCloseByRequiredTag();
    if (!canClose) return;
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "closed",
        userId: user?.id || null,
        queueId: ticket?.queue?.id || ticket?.queueId || null, // ✅ Preservar fila ao fechar
        sendFarewellMessage: false,
        amountUsedBotQueues: 0,
        triggerIntegrationOnCloseAction:
          triggerIntegrationOnCloseMode === "trigger",
      });

      setLoading(false);
      history.push("/tickets");
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleOpenExportPdfChoice = () => {
    handleCloseMenu();
    setExportPdfChoiceModalOpen(true);
  };

  const handleExportPdfChoice = (mode) => {
    setPdfExportMode(mode);
    setExportPdfChoiceModalOpen(false);
    setOpenTicketMessageDialog(true);
  };

  const handleCloseTicketMessageDialog = () => {
    setOpenTicketMessageDialog(false);
    setPdfExportMode(null);
  };

  const handleEnableIntegration = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        useIntegration: !enableIntegration,
      });
      setEnableIntegration(!enableIntegration);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleShowLogTicket = async () => {
    setShowTicketLogOpen(true);
  };

  const handleContactToggleDisableBot = async () => {
    if (!ticket?.contact?.id) {
      toastError(new Error("Contato não encontrado"));
      return;
    }

    const { id } = ticket.contact;

    try {
      const { data } = await api.put(`/contacts/toggleDisableBot/${id}`);
      if (ticket.contact) {
        ticket.contact.disableBot = data.disableBot;
      }
      setDisableBot(data.disableBot);
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseTransferTicketModal = () => {
    setTransferTicketModalOpen(false);
  };

  const handleOpenNewTicketModal = () => {
    setNewTicketModalOpen(true);
  };

  const handleCloseNewTicketModal = (newTicket) => {
    setNewTicketModalOpen(false);
    if (newTicket) {
      // Se um novo ticket foi criado, redirecionar para ele
      setCurrentTicket({ id: newTicket.id, uuid: newTicket.uuid, code: uuidv4() });
      history.push(`/tickets/${newTicket.uuid}`);
    }
  };

  const handleDeleteTicket = async () => {
    try {
      await api.delete(`/tickets/${ticket.id}`);
      history.push("/tickets");
    } catch (err) {
      toastError(err);
    }
  };

  const handleSendMessage = async (id) => {
    let setting;

    try {
      setting = await getSetting({
        column: "greetingAcceptedMessage",
      });
    } catch (err) {
      toastError(err);
    }
    if (!setting.greetingAcceptedMessage) {
      toast.warning(
        i18n.t("messagesList.header.buttons.greetingAcceptedMessage")
      );
      return;
    }
    const msg = `${setting.greetingAcceptedMessage}`; //`{{ms}} *{{name}}*, ${i18n.t("mainDrawer.appBar.user.myName")} *${user?.name}* ${i18n.t("mainDrawer.appBar.user.continuity")}.`;
    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: `${msg.trim()}`,
    };
    try {
      await api.post(`/messages/${id}`, message);
    } catch (err) {
      toastError(err);
    }
  };

  const handleUpdateTicketStatus = async (e, status, userId, queueId, extraData = {}) => {
    console.log("[GREETING] TicketActionButtonsCustom.handleUpdateTicketStatus called, status:", status);
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: status,
        userId: userId || null,
        queueId: queueId || ticket?.queue?.id || ticket?.queueId || null, // ✅ Preservar fila ao fechar
        ...(status === "closed" && triggerIntegrationOnCloseMode === "trigger"
          ? { triggerIntegrationOnCloseAction: true }
          : {}),
        ...extraData,
      });

      let setting;

      try {
        setting = await getSetting({
          column: "sendGreetingAccepted",
        });
      } catch (err) {
        toastError(err);
      }

      const greetingMode = setting?.sendGreetingAccepted || "disabled";
      // shouldGreet: só verifica grupo (status já era "pending" antes do api.put acima)
      const shouldGreet =
        (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") &&
        status === "open"; // usar o parametro status (destino) ao inves de ticket.status (pode ter sido atualizado via websocket)

      if (shouldGreet && greetingMode === "enabled") {
        await handleSendMessage(ticket.id);
      } else if (shouldGreet && greetingMode === "ask") {
        const confirmed = await confirmDialog({
          title: i18n.t("settings.settings.options.sendGreetingAccepted"),
          message: i18n.t("settings.settings.options.askGreetingConfirm"),
        });
        if (confirmed) {
          await handleSendMessage(ticket.id);
        }
      }

      if (isMounted.current) {
        setLoading(false);
      }

      if (status === "open" || status === "group") {
        setCurrentTicket({ ...ticket, code: "#" + status });
        setTimeout(() => {
          history.push("/tickets");
        }, 0);

        setTimeout(() => {
          history.push(`/tickets/${ticket.uuid}`);
          setTabOpen(status);
        }, 10);
      } else {
        setCurrentTicket({ id: null, code: null });
        history.push("/tickets");
      }
    } catch (err) {
      if (isMounted.current) {
        setLoading(false);
      }
      toastError(err);
    }
  };

  const handleAcepptTicket = async (id) => {
    setLoading(true);
    try {
      const otherTicket = await api.put(`/tickets/${id}`, {
        status: ticket.isGroup ? "group" : "open",
        userId: user?.id,
      });
      if (otherTicket.data.id !== ticket.id) {
        if (otherTicket.data.userId !== user?.id) {
          if (isMounted.current) {
            setOpenAlert(true);
            setUserTicketOpen(otherTicket.data.user.name);
            setQueueTicketOpen(otherTicket.data.queue.name);
            setTabOpen(otherTicket.isGroup ? "group" : "open");
          }
        } else {
          if (isMounted.current) {
            setLoading(false);
            setTabOpen(otherTicket.isGroup ? "group" : "open");
          }
          history.push(`/tickets/${otherTicket.data.uuid}`);
        }
      } else {
        if (isMounted.current) {
          setLoading(false);
        }
        history.push("/tickets");
        setTimeout(() => {
          history.push(`/tickets/${ticket.uuid}`);
          setTabOpen(ticket.isGroup ? "group" : "open");
        }, 1000);
      }
    } catch (err) {
      if (isMounted.current) {
        setLoading(false);
      }
      toastError(err);
    }
  };

  //Wavoip historic
  const saveHistoricalLink = async (payload) => {
    try {
      await api.post(`/call/historical/wavoip`, payload);
    } catch (err) {
      console.error('Erro ao salvar histórico de chamada:', err);
    }
  }
  // Click-to-call: abre o webphone oficial e inicia a ligação com o número do contato
  const handleOpenWavoipCall = async () => {
    if (!ticket?.contact?.number) {
      toastError("Erro: Número de telefone não disponível.");
      return;
    }

    const token = ticket?.whatsapp?.wavoip || null;
    const phone = ticket.contact.number.replace(/\D/g, "");
    const name = ticket.contact.name || "";
    const url = `https://app.wavoip.com/call?token=${token}&phone=${phone}&name=${name}&start_if_ready=true&close_after_call=true`;

    // Salva histórico em segundo plano (não bloqueia a ligação)
    saveHistoricalLink({
      "user_id": ticket?.user?.id || null,
      "token_wavoip": token,
      "whatsapp_id": ticket?.whatsapp?.id || null,
      "contact_id": ticket?.contact?.id || null,
      "company_id": ticket?.company?.id || null,
      "phone_to": phone,
      "name": name,
      "url": url,
      "createdAt": new Date()
    }).catch((e) => console.error('Erro ao salvar histórico de chamada:', e));

    // Preferência: webphone novo (widget oficial) com click-to-call — resposta imediata
    if (typeof window !== "undefined" && window.wavoip) {
      try {
        window.wavoip.widget.toggle();
        window.wavoip.settings.setShowSettings(false);
        if (window.wavoip?.position?.set) {
          window.wavoip.position.set("bottom-right");
        }
        const tokenToUse = token;
        if (tokenToUse) {
          window.wavoip.device.addDevice(tokenToUse);
          const result = await window.wavoip.call.startCall(phone, [tokenToUse]);
          if (result?.err) {
            toastError(result.err?.message || "Erro ao iniciar chamada.");
          }
        } else {
          toastError("Token WAVoIP não disponível para esta conexão.");
        }
      } catch (err) {
        console.error("Erro click-to-call webphone:", err);
        toastError(err?.message || "Erro ao abrir webphone.");
        if (token) {
          window.open(url, "wavoip", "toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=500,height=700");
        }
      }
      return;
    }

    // Fallback: popup externo quando o widget ainda não estiver carregado
    if (token) {
      window.open(url, "wavoip", "toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=500,height=700");
    } else {
      toastError("Token WAVoIP não disponível. Aguarde o carregamento do webphone ou tente novamente.");
    }
  };

  const handleExportToPDF = () => {
    const messagesListElement = document.getElementById("messagesList");
    const headerElement = document.getElementById("TicketHeader");

    const pdfOptions = {
      margin: 1,
      filename: `${i18n.t("whatsappModalRel.form.reportFilename")}${ticket.id
        }.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    if (messagesListElement && headerElement) {
      const headerClone = headerElement.cloneNode(true);
      const messagesListClone = messagesListElement.cloneNode(true);

      const containerElement = document.createElement("div");
      containerElement.appendChild(headerClone);
      containerElement.appendChild(messagesListClone);

      return html2pdf().from(containerElement).set(pdfOptions).output("blob");
    } else {
      toast.error(i18n.t("whatsappModalRel.form.elementNotFoundForExport"));
      return null;
    }
  };

  const handleTestButton = async () => {
    try {
      // Fecha o ticket e dispara a integração apenas quando o usuário clica em "Resolver e Disparar Integração"
      await handleUpdateTicketStatus(
        null,
        "closed",
        user?.id,
        ticket?.queue?.id,
        { triggerIntegrationOnCloseAction: true }
      );

      if (isMounted.current) {
        toast.success(i18n.t("ticketList.success.integrationTriggered"));
        handleClose();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleLinkToWallet = async () => {
    if (!ticket.contactId) {
      toast.error(i18n.t("contactModal.saveFirst"));
      return;
    }

    setLinkingWallet(true);
    try {
      if (!user.queues || user.queues.length === 0) {
        toast.error(i18n.t("contactModal.walletError"));
        return;
      }

      // Usa a primeira fila do usuário
      const userQueue = user.queues[0];

      await api.put(`/contacts/wallet/${ticket.contactId}`, {
        wallets: {
          userId: user.id,
          queueId: ticket.queueId || userQueue.id,
        },
      });

      toast.success(i18n.t("contactModal.walletLinked"));
    } catch (err) {
      toastError(err);
    } finally {
      setLinkingWallet(false);
    }
  };

  const handleFinalizarTicket = async (tipo) => {
    if (exigirMotivoFinalizacao) {
      setFinalizacaoTipo(tipo);
      setOpenFinalizacaoVenda(true);
    } else {
      const canClose = await checkCanCloseByRequiredTag();
      if (!canClose) return;
      if (tipo === "semDespedida") {
        handleCloseTicketWithoutFarewellMsg();
      } else {
        handleUpdateTicketStatus(null, "closed", user?.id, ticket?.queue?.id);
      }
    }
  };

  const checkCanCloseByRequiredTag = async () => {
    const setting = await getSetting({ column: "requiredTag" });
    if (setting?.requiredTag !== "enabled") return true;
    if (!ticket?.contact?.id) {
      toast.warning("Contato não encontrado");
      return false;
    }
    try {
      const contactTags = await api.get(`/contactTags/${ticket.contact.id}`);
      if (!contactTags.data.tags) {
        toast.warning(i18n.t("messagesList.header.buttons.requiredTag"));
        return false;
      }
      return true;
    } catch (err) {
      toastError(err);
      return false;
    }
  };

  const handleClickResolver = async () => {
    if (exigirMotivoFinalizacao) {
      const canClose = await checkCanCloseByRequiredTag();
      if (!canClose) return;
      setFinalizacaoTipo("comDespedida");
      setOpenFinalizacaoVenda(true);
    } else {
      const canClose = await checkCanCloseByRequiredTag();
      if (!canClose) return;
      setOpen(true);
    }
  };

  const handleUpdateTicketStatusWithData = async (
    ticketData,
    sendFarewellMessage,
    finalizacaoMessage
  ) => {
    try {
      await api.put(`/tickets/${ticket.id}`, {
        ...ticketData,
        sendFarewellMessage,
        finalizacaoMessage,
        ...(ticketData?.status === "closed" &&
        triggerIntegrationOnCloseMode === "trigger"
          ? { triggerIntegrationOnCloseAction: true }
          : {}),
      });
      toast.success("Ticket finalizado com sucesso!");
      // Atualize o estado conforme necessário
    } catch (err) {
      toastError(err);
    }
  };

  // Tooltip dinâmico para copiar telefone
  const getCopyPhoneTooltip = () => {
    const usePrefixWhenCopy = localStorage.getItem('usePrefixWhenCopy') === 'true';
    const prefix = localStorage.getItem('contactCopyPrefix') || '';

    let copyTooltip = i18n.t("ticketInfo.copyPhone");
    if (usePrefixWhenCopy && prefix) {
      copyTooltip = `Copiar telefone com prefixo (${prefix})`;
    }
    return copyTooltip;
  };

  return (
    <>
      {openAlert && (
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
      )}
      {acceptTicketWithouSelectQueueOpen && (
        <AcceptTicketWithouSelectQueue
          modalOpen={acceptTicketWithouSelectQueueOpen}
          onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
          ticketId={ticket.id}
          ticket={ticket}
        />
      )}
      {showTicketLogOpen && (
        <ShowTicketLogModal
          isOpen={showTicketLogOpen}
          handleClose={(e) => setShowTicketLogOpen(false)}
          ticketId={ticket.id}
        />
      )}
      {exportPdfChoiceModalOpen && (
        <Dialog
          open={exportPdfChoiceModalOpen}
          onClose={() => setExportPdfChoiceModalOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Exportar conversa para PDF</DialogTitle>
          <DialogContent>
            <Typography>Como deseja exportar?</Typography>
          </DialogContent>
          <DialogActions style={{ flexDirection: "column", gap: 8, padding: 16 }}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => handleExportPdfChoice("screen")}
            >
              Apenas o que está em tela
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => handleExportPdfChoice("fullHistory")}
            >
              Todo o histórico
            </Button>
            <Button onClick={() => setExportPdfChoiceModalOpen(false)}>
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openTicketMessageDialog && (
        <TicketMessagesDialog
          open={openTicketMessageDialog}
          handleClose={handleCloseTicketMessageDialog}
          ticketId={ticket.id}
          exportMode={pdfExportMode}
          ticket={ticket}
        />
      )}

      {quickMessageModalOpen && (
        <QuickMessageModal
          open={quickMessageModalOpen}
          onClose={handleCloseQuickMessageModal}
          onSelect={handleQuickMessageSelect}
          companyId={user?.companyId}
          userId={user?.id}
        />
      )}

      {newTicketModalOpen && (
        <NewTicketModal
          modalOpen={newTicketModalOpen}
          onClose={handleCloseNewTicketModal}
          initialContact={contact}
        />
      )}

      <PauseTicketModal
        open={pauseModalOpen}
        onClose={() => setPauseModalOpen(false)}
        ticketId={ticket.id}
        onPaused={() => {
          setPauseModalOpen(false);
        }}
      />

      <div className={classes.actionButtons}>
        {ticket.status === "paused" && (
          <>
            <Tooltip title="Retomar atendimento">
              <ButtonWithSpinner
                loading={loading}
                startIcon={<PlayCircleFilledIcon />}
                size="small"
                style={{ backgroundColor: "#4CAF50", color: "#fff" }}
                onClick={async () => {
                  setLoading(true);
                  try {
                    await resumeTicket(ticket.id);
                    toast.success("Ticket retomado!");
                  } catch (err) {
                    toastError(err);
                  }
                  setLoading(false);
                }}
              >
                Retomar
              </ButtonWithSpinner>
            </Tooltip>
            {ticket.pauseReasonName && (
              <Tooltip title={`Motivo: ${ticket.pauseReasonName}${ticket.pauseNote ? ` — ${ticket.pauseNote}` : ""}`}>
                <span style={{
                  fontSize: "0.7rem",
                  color: "#FF9800",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  whiteSpace: "nowrap",
                }}>
                  <PauseCircleFilledIcon style={{ fontSize: 14, color: "#FF9800" }} />
                  {ticket.pauseReasonName}
                </span>
              </Tooltip>
            )}
          </>
        )}
        {ticket.status === "closed" && (
          <ButtonWithSpinner
            loading={loading}
            startIcon={<Add />}
            size="small"
            onClick={handleOpenNewTicketModal}
          >
            Criar Novo Ticket
          </ButtonWithSpinner>
        )}
        {/* <IconButton
                    className={classes.bottomButtonVisibilityIcon}
                    onClick={handleShowLogTicket}
                >
                    <Tooltip title={i18n.t("messagesList.header.buttons.logTicket")}>
                        <History />

                    </Tooltip>
                </IconButton> */}
        {(ticket.status === "open" || ticket.status === "group") && (
          <>
            {/* {!showSelectMessageCheckbox ? ( */}
            <>
              {/* <IconButton
                                className={classes.bottomButtonVisibilityIcon}
                                onClick={handleEnableIntegration}
                            >
                                <Tooltip title={i18n.t("messagesList.header.buttons.enableIntegration")}>
                                    {enableIntegration === true ? <DeviceHubOutlined style={{ color: "green" }} /> : <DeviceHubOutlined />}

                                </Tooltip>
                            </IconButton> */}

              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={() => setContactCustomFieldsOpen(true)}
                disabled={!contact?.id}
              >
                <Tooltip title={i18n.t("ticketInfo.openCustomFieldsButton")}>
                  <Tune />
                </Tooltip>
              </IconButton>

              {/* Ícone para copiar telefone */}
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleCopyPhone}
                disabled={!contact?.number}
              >
                <Tooltip title={getCopyPhoneTooltip()}>
                  <FileCopyIcon />
                </Tooltip>
              </IconButton>

              {/* Ícone para respostas rápidas */}
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleOpenQuickMessageModal}
              >
                <Tooltip title={i18n.t("ticketInfo.quickMessages")}>
                  <FlashOn />
                </Tooltip>
              </IconButton>

              {/* Ícone para enviar chave PIX no ticket */}
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleSendPixKey}
                disabled={sendingPixKey || !ticket?.whatsappId}
              >
                <Tooltip title={i18n.t("ticketInfo.sendPixKey")}>
                  {sendingPixKey ? (
                    <CircularProgress size={20} />
                  ) : (
                    <PixIcon style={{ color: "#00BFA5" }} />
                  )}
                </Tooltip>
              </IconButton>

              {/* Botão de vincular à carteira só aparece se NÃO houver carteira vinculada E se a configuração DirectTicketsToWallets estiver ativa */}
              {directTicketsToWallets && !(
                ticket.contact?.contactWallets &&
                ticket.contact.contactWallets.length > 0
              ) && (
                  <IconButton
                    className={classes.bottomButtonVisibilityIcon}
                    onClick={handleLinkToWallet}
                    disabled={linkingWallet}
                  >
                    <Tooltip title="Vincular à minha carteira">
                      {linkingWallet ? (
                        <CircularProgress size={20} />
                      ) : (
                        <AccountBalanceWallet />
                      )}
                    </Tooltip>
                  </IconButton>
                )}
            </>

            {/* {showSchedules && (
                            <>
                                <IconButton className={classes.bottomButtonVisibilityIcon}>
                                    <Tooltip title={i18n.t("tickets.buttons.scredule")}>
                                        <EventIcon
                                            // color="primary"
                                            onClick={handleOpenScheduleModal}
                                        />
                                    </Tooltip>
                                </IconButton>
                            </>
                        )} */}

            {/* Botão FollowUp - fora do menu */}
            <FloupSelector contact={contact} ticket={ticket} />

            {/* Botão Pausar */}
            <Tooltip title="Pausar atendimento">
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={() => setPauseModalOpen(true)}
              >
                <PauseCircleFilledIcon style={{ color: "#FF9800" }} />
              </IconButton>
            </Tooltip>

            {/* Botão Resolver - fora do menu */}
            <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleClickResolver}
              >
                <HighlightOffIcon />
              </IconButton>
            </Tooltip>

            {/* Botão Transferir - fora do menu */}
            <Tooltip title="Transferir Ticket">
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleOpenTransferModal}
              >
                <SwapHorizOutlined />
              </IconButton>
            </Tooltip>

            {confirmationOpen && (
              <ConfirmationModal
                title={`${i18n.t(
                  "ticketOptionsMenu.confirmationModal.title"
                )} #${ticket.id}?`}
                open={confirmationOpen}
                onClose={setConfirmationOpen}
                onConfirm={handleDeleteTicket}
              >
                {i18n.t("ticketOptionsMenu.confirmationModal.message")}
              </ConfirmationModal>
            )}
            {transferTicketModalOpen && (
              <TransferTicketModalCustom
                modalOpen={transferTicketModalOpen}
                onClose={handleCloseTransferTicketModal}
                ticketid={ticket.id}
                ticket={ticket}
              />
            )}
          </>
        )}
        {ticket.status === "pending" &&
          (ticket.queueId === null || ticket.queueId === undefined) && (
            <ButtonWithSpinner
              loading={loading}
              size="small"
              variant="contained"
              onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
            >
              {i18n.t("messagesList.header.buttons.accept")}
            </ButtonWithSpinner>
          )}
        {ticket.status === "pending" && ticket.queueId !== null && (
          <ButtonWithSpinner
            loading={loading}
            size="small"
            variant="contained"
            // color="primary"
            onClick={(e) => handleUpdateTicketStatus(e, "open", user?.id)}
          >
            {i18n.t("messagesList.header.buttons.accept")}
          </ButtonWithSpinner>
        )}
        <IconButton
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
          style={{ paddingHorizontal: 3, paddingTop: 10 }}
        >
          <MoreVert style={{ fontSize: 16, padding: 0 }} />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleCloseMenu}
        >
          {(ticket.status === "open" || ticket.status === "group") && [
            showWavoipCall && (
              <MenuItem key="wavoip-call" onClick={() => { handleOpenWavoipCall(); handleCloseMenu(); }}>
                <Phone style={{ marginRight: 8, fontSize: 20 }} />
                Ligar
              </MenuItem>
            ),
            <MenuItem key="disable-bot" onClick={() => { handleContactToggleDisableBot(); handleCloseMenu(); }}>
              <Switch
                size="small"
                checked={disableBot}
                onClick={(e) => e.stopPropagation()}
                onChange={() => handleContactToggleDisableBot()}
                style={{ marginRight: 8 }}
              />
              {disableBot ? "Ativar Bot" : "Desabilitar Bot"}
            </MenuItem>,
            <MenuItem key="return-queue" onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}>
              <UndoIcon style={{ marginRight: 8, fontSize: 20 }} />
              {i18n.t("tickets.buttons.returnQueue")}
            </MenuItem>
          ]}
          <MenuItem onClick={handleOpenConfirmationModal}>
            <Can
              role={user.profile}
              perform="ticket-options:deleteTicket"
              yes={() => i18n.t("tickets.buttons.deleteTicket")}
            />
          </MenuItem>
          <MenuItem onClick={handleEnableIntegration}>
            {enableIntegration === true
              ? i18n.t("messagesList.header.buttons.disableIntegration")
              : i18n.t("messagesList.header.buttons.enableIntegration")}
          </MenuItem>
          <MenuItem onClick={handleShowLogTicket}>
            {i18n.t("messagesList.header.buttons.logTicket")}
          </MenuItem>
          <MenuItem onClick={handleOpenExportPdfChoice}>
            {i18n.t("ticketsList.buttons.exportAsPDF")}
          </MenuItem>
        </Menu>
      </div>
      <>
        {!exigirMotivoFinalizacao && (
            <Formik
              enableReinitialize={true}
              validationSchema={SessionSchema}
              innerRef={formRef}
              onSubmit={(values, actions) => {
                setTimeout(() => {
                  actions.setSubmitting(false);
                  actions.resetForm();
                }, 400);
              }}
            >
              {({
                values,
                touched,
                errors,
                isSubmitting,
                setFieldValue,
                resetForm,
              }) => (
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <Form>
                    <DialogActions className={classes.botoes}>
                      <Button
                        onClick={() => handleFinalizarTicket("semDespedida")}
                        style={{
                          background: theme.palette.primary.main,
                          color: "white",
                        }}
                      >
                        {i18n.t(
                          "messagesList.header.dialogRatingWithoutFarewellMsg"
                        )}
                      </Button>

                      <Button
                        onClick={() => handleFinalizarTicket("comDespedida")}
                        style={{
                          background: theme.palette.primary.main,
                          color: "white",
                        }}
                      >
                        {i18n.t("messagesList.header.dialogRatingCancel")}
                      </Button>

                      {showTestButton &&
                        triggerIntegrationOnCloseMode === "ask" && (
                        <Button
                          onClick={handleTestButton}
                          style={{
                            background: theme.palette.primary.main,
                            color: "white",
                          }}
                        >
                          {i18n.t(
                            "whatsappModalRel.form.resolveAndTriggerIntegration"
                          )}
                        </Button>
                        )}
                    </DialogActions>
                  </Form>
                </Dialog>
              )}
            </Formik>
          )}
      </>
      {openFinalizacaoVenda && (
            <FinalizacaoVendaModal
              open={openFinalizacaoVenda}
              onClose={() => setOpenFinalizacaoVenda(false)}
              ticket={ticket}
              onFinalizar={(ticketData) => {
                setOpenFinalizacaoVenda(false);
                setTicketDataToFinalize(ticketData);
                setShowFinalizacaoOptions(true);
              }}
            />
          )}
      {showFinalizacaoOptions && (
        <Dialog
          open={showFinalizacaoOptions}
          onClose={() => setShowFinalizacaoOptions(false)}
          aria-labelledby="finalizacao-options-title"
        >
          <DialogTitle id="finalizacao-options-title">
            Como deseja finalizar?
          </DialogTitle>
          <DialogActions className={classes.botoes}>
            <Button
              onClick={async () => {
                const canClose = await checkCanCloseByRequiredTag();
                if (!canClose) return;
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  false,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
            </Button>
            <Button
              onClick={async () => {
                const canClose = await checkCanCloseByRequiredTag();
                if (!canClose) return;
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  true,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingCancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <ContactCustomFieldsDrawer
        open={contactCustomFieldsOpen}
        onClose={() => setContactCustomFieldsOpen(false)}
        contactId={contact?.id}
        onSaved={(patch) => {
          if (typeof onContactUpdated === "function") {
            onContactUpdated(patch);
          }
        }}
      />
    </>
  );
};

export default TicketActionButtonsCustom;